module.exports = __webpack_public_path__ + "static/media/vacuolo.85b07433.gif";